import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSettingsStore } from '@/store';
// import { useSettingsStore } from '@/store/settingsStore';

interface WhatsAppButtonProps {
  className?: string;
}

export function WhatsAppButton({ className = '' }: WhatsAppButtonProps) {

  const { settings } = useSettingsStore();
 
  const handleClick = () => {
    const url = `https://wa.me/${settings.whatsappNumber}${settings.whatsappMessage ? `?text=${encodeURIComponent(settings.whatsappMessage)}` : ''}`;
    window.open(url, '_blank');
  };

  return (
    <Button
      onClick={handleClick}
      className={`bg-[#25D366] hover:bg-[#128C7E] ${className}`}
      title="تواصل عبر واتساب"
    >
      <MessageCircle className="h-4 w-4 ml-2" />
      واتساب
    </Button>
  );
}